import React, { useEffect } from 'react'
import { Facebook } from 'react-content-loader'
import { useDispatch, useSelector } from 'react-redux'
import { fetchposts } from '../features/posts/postSlice'
import Post from './Post'

const Posts = () => {



  const dispatch =useDispatch()




  const { posts,savedPosts, isLoading, isError, error } = useSelector(
      (state) => state.posts
  );
  const { filter,sort} = useSelector(
      (state) => state.filterPosts
  );




useEffect(()=>{
  dispatch(fetchposts({filter,sort}))
},[filter,sort])
  // decide what to render
  let content;

  if (isLoading) content = <Facebook />;
  if (!isLoading && isError)
      content = <div className="col-span-12">{error}</div>;

  if (!isError && !isLoading && posts?.length === 0) {
      content = <div className="col-span-12">No Posts found!</div>;
  }

  if (!isError && !isLoading && posts?.length > 0) {
      content = posts.map((post) => (
          <Post key={post.id} post={post} />
      ));
  }


  return (
    <>
        
      <main className="post-container" id="lws-postContainer">
 
 {content}

</main>

    </>
  )
}

export default Posts